import { apiSlice } from "../../app/api/apiSlice";

export const userDashboardApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserEvaluationSessions: builder.query({
            query: (userId) => {
                let url = `/api/v1/resources/evaluation_sessions/?page_size=100`;
                if (userId) {
                    url += `&trainee=${userId}`;
                }
                return url;
            },
            keepUnusedDataFor: 5,
        }),
        getEvaluationStats: builder.query({
            query: () => `/api/v1/resources/evaluation_sessions/stats/`,
            keepUnusedDataFor: 60,
        }),
        getCoachingTips: builder.query({
            query: (userId) => {
                let url = `/api/v1/resources/evaluation_sessions/coaching/`;
                if (userId) {
                    url += `?trainee=${userId}`;
                }
                return url;
            },
            keepUnusedDataFor: 60,
        }),
        getUserDynamicPersonas: builder.query({
            query: (userId) => ({
                url: "/api/v1/resources/customer_personas/",
                params: {
                    scope: "user_only",
                    user: userId,
                    include_deactivated: "true",
                },
            }),
            providesTags: ["CustomerPersona"],
        }),
    }),
});

export const { useGetUserEvaluationSessionsQuery, useGetEvaluationStatsQuery, useGetCoachingTipsQuery, useGetUserDynamicPersonasQuery } = userDashboardApiSlice;
